import React from 'react';
import { ModalDialog, ButtonBar } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';

interface FeedCreationLimitDialogProps {
  show: boolean;
  onClose: () => void;
}

// Shown when the server rejects a new public feed with a FeedCreationLimit error: the user has hit
// the hard per-user creation cap. Distinct from FeedQuotaDialog (a per-plan subscription quota) —
// there is nothing the user can do to free up space, so we point them at support.
const FeedCreationLimitDialog: React.FC<FeedCreationLimitDialogProps> = ({ show, onClose }) => {
  return (
    <ModalDialog
      show={show}
      title="Feed Creation Limit Reached"
      closeButton="close"
      onClose={onClose}
    >
      <p>
        You've reached the maximum number of feeds you can create. If you need to add more,
        please contact support and we'll be happy to help.
      </p>
      <ButtonBar className="full-margin-top" align="right">
        <TextButton type="major" onClick={onClose} label="OK" />
      </ButtonBar>
    </ModalDialog>
  );
};

export default FeedCreationLimitDialog;
